module.exports = __webpack_public_path__ + "img/ic_ride_bike.343107fb.svg";